/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryResponse,
  GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryParams,
  GetApiV1DocumentCourseRegistrationAttachmentDownload401,
  GetApiV1DocumentCourseRegistrationAttachmentDownload403,
  GetApiV1DocumentCourseRegistrationAttachmentDownload404,
  GetApiV1DocumentCourseRegistrationAttachmentDownload500,
} from "../../types/documentCourseRegistrationController/GetApiV1DocumentCourseRegistrationAttachmentDownload.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1DocumentCourseRegistrationAttachmentDownload } from "../../clients/documentCourseRegistrationController/getApiV1DocumentCourseRegistrationAttachmentDownload.ts";

export const getApiV1DocumentCourseRegistrationAttachmentDownloadQueryKey = (
  params?: GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryParams,
) =>
  [
    { url: "/api/v1/document/course-registration/attachment-download" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryKey =
  ReturnType<
    typeof getApiV1DocumentCourseRegistrationAttachmentDownloadQueryKey
  >;

export function getApiV1DocumentCourseRegistrationAttachmentDownloadQueryOptions(
  params?: GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1DocumentCourseRegistrationAttachmentDownloadQueryKey(params);
  return queryOptions<
    GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryResponse,
    ResponseErrorConfig<
      | GetApiV1DocumentCourseRegistrationAttachmentDownload401
      | GetApiV1DocumentCourseRegistrationAttachmentDownload403
      | GetApiV1DocumentCourseRegistrationAttachmentDownload404
      | GetApiV1DocumentCourseRegistrationAttachmentDownload500
    >,
    GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1DocumentCourseRegistrationAttachmentDownload(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Gera e retorna uma URL assinada para download do arquivo anexado à pessoa. Retorna 403 caso o anexo não pertença ao usuário autenticado e 404 caso o anexo não seja encontrado. **(Requer Authorization para autenticação)**
 * @summary Retorna URL de download de um anexo de pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/document/course-registration/attachment-download}
 */
export function useGetApiV1DocumentCourseRegistrationAttachmentDownload<
  TData = GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryResponse,
  TQueryData =
    GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryKey,
>(
  params?: GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryResponse,
        ResponseErrorConfig<
          | GetApiV1DocumentCourseRegistrationAttachmentDownload401
          | GetApiV1DocumentCourseRegistrationAttachmentDownload403
          | GetApiV1DocumentCourseRegistrationAttachmentDownload404
          | GetApiV1DocumentCourseRegistrationAttachmentDownload500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1DocumentCourseRegistrationAttachmentDownloadQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1DocumentCourseRegistrationAttachmentDownloadQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1DocumentCourseRegistrationAttachmentDownload401
      | GetApiV1DocumentCourseRegistrationAttachmentDownload403
      | GetApiV1DocumentCourseRegistrationAttachmentDownload404
      | GetApiV1DocumentCourseRegistrationAttachmentDownload500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
